import profile from "@/http/requests/whatsappProfile"

export default {
  fetch({ commit }, data) {
    return new Promise((resolve, reject) => {
      profile.fetch(data)
        .then(response => {
          commit('SET_PROFILE', response.data.data.whatsappProfile)
          resolve(response)
        }).catch((error) => { reject(error) })
    })
  },
  update({ commit }, data) {
    return new Promise((resolve, reject) => {
      profile.update(data)
        .then(response => {
          commit('UPDATE_PROFILE', data.profile)
          resolve(response)
        }).catch((error) => { reject(error) })
    })
  },
  updatePicture({ commit }, data) {
    return new Promise((resolve, reject) => {
      profile.updatePicture(data)
        .then(response => {
          commit('UPDATE_PROFILE', { profile_picture_url: data.picture })
          resolve(response)
        }).catch((error) => { reject(error) })
    })
  }
}
